import { StrictRecord } from '../../../utils/utilityTypes';

export const OTHER = 'other';

export type StrictScopeGroupTopLevelCategory =
  | 'crm'
  | 'cms'
  | 'settings'
  | typeof OTHER;

export const SCOPE_GROUP_TOP_LEVEL_GROUPINGS: StrictRecord<StrictScopeGroupTopLevelCategory> =
  {
    crm: 'crm',
    cms: 'cms',
    settings: 'settings',
    other: OTHER,
  } as const;

export const PREFERRED_SCOPE_GROUP_GROUPINGS = [
  SCOPE_GROUP_TOP_LEVEL_GROUPINGS.crm,
  SCOPE_GROUP_TOP_LEVEL_GROUPINGS.cms,
] as const;
